<template lang="pug">
vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(autofocus :placeholder='$t("invoices.compaq_placeholder")' :danger="$v.form.compaq.$invalid && $v.form.compaq.$model" :danger-text="$t('validation.required', { attribute: $t('invoices.compaq') })" v-model="form.compaq" :label='$t("invoices.compaq")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group.separator
        vm-date-picker.full-width(type="date" :label="$t('invoices.portal_date')" :placeholder="$t('strings.select_date')" v-model="form.portal_date" )
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        span {{ $t('invoices.signature') }}
        vm-switch(v-model="form.signature")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-textarea(:label="$t('invoices.comments')" counter="300" v-model="form.comments")
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Invoices')

export default {
  name: 'ModalInvoices',
  mixins: [ModalMixin1],
  // data: () => ({}),
  validations () {
    return {
      form: {
        compaq: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog'])
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog'
    ])
  }
}
</script>
